import { TBctxItemWithoutSizeAndBctxKey, TBundleQcCountInfo, TBundleQcStore, TIncompleteBundle } from '@monorepo/types';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  getBctxWipMap,
  getIncompleteBundlesInfoForCurrentStationAndShift,
  getselectedBctxInfo,
  getSelectedStationIdAndShiftId,
} from '../input-app-client-db/input-app-client-db.query';
import {
  getMultipleRoundsDefectivesForCurrentLineAndShift,
  getMultipleRoundsDefectivesForCurrentLineAndShiftAndSelectedBctxAndInitStatus,
} from '../server-defectives-db/server-defectives-db.query';
import { DEFAULT_LINE_SHIFT_INCOMPLETE_BUNDLE_SYNC_INFO } from './bundle-qc.reducer';

export const selectBundleQcStore = createFeatureSelector<TBundleQcStore>('BUNDLE_QC_DB');
export const getBundleQcBgDBLockDetails = createSelector(selectBundleQcStore, (selectBundleQcStore) => {
  return selectBundleQcStore.bundleQcBgDBLockDetails;
});

export const getBgDBForCurrentStationAndShift = createSelector(
  selectBundleQcStore,
  getSelectedStationIdAndShiftId,
  (selectBundleQcStore, { shiftId, stationId }) => {
    return selectBundleQcStore.bundleQcBgDB[stationId] && selectBundleQcStore.bundleQcBgDB[stationId][shiftId]
      ? selectBundleQcStore.bundleQcBgDB[stationId][shiftId].lastSyncedAt
      : DEFAULT_LINE_SHIFT_INCOMPLETE_BUNDLE_SYNC_INFO.lastSyncedAt;
  },
);
export const getUpdatedAtAndLastSyncedAt = createSelector(
  getIncompleteBundlesInfoForCurrentStationAndShift,
  getBgDBForCurrentStationAndShift,
  ({ lastUpdatedAt }, lastSyncedAt) => {
    return {
      lastUpdatedAt: lastUpdatedAt,
      lastSyncedAt: lastSyncedAt,
    };
  },
);
export const getCurrentBctxCounts = createSelector(
  getIncompleteBundlesInfoForCurrentStationAndShift,
  getMultipleRoundsDefectivesForCurrentLineAndShiftAndSelectedBctxAndInitStatus,
  getselectedBctxInfo,
  getBctxWipMap,
  (incompleteBundlesInfo, defectivesInfo, selectedBctxInfo, wipMap) => {
    const bctxKey = selectedBctxInfo.bctxInfoWithoutSize.bctxKey;
    if (selectedBctxInfo.bctxInfoWithoutSize.list.length === 0) {
      return {
        initialBundleQty: 0,
        availableWip: 0,
        remainingDefectives: 0,
        hasDefectivesInitialized: false,
      };
    } else {
      const incompleteBundle = incompleteBundlesInfo.list.find(({ g_ctx_key }) => g_ctx_key === bctxKey);
      let availableWip = 0;
      if (wipMap[bctxKey]) {
        availableWip = Object.values(wipMap[bctxKey].sizeToWipMap)[0].wip_qty;
      }
      const result: TBundleQcCountInfo = {
        initialBundleQty:
          incompleteBundle && incompleteBundle.size_list ? incompleteBundle.size_list[0].qty : availableWip,
        availableWip,
        remainingDefectives: defectivesInfo.defects.length,
        hasDefectivesInitialized: defectivesInfo.hasInitialized,
      };
      return result;
    }
  },
);

export const getActiveBctxList = createSelector(
  getMultipleRoundsDefectivesForCurrentLineAndShift,
  getBctxWipMap,
  getIncompleteBundlesInfoForCurrentStationAndShift,
  (defectives, wipMap, incompleteBundles) => {
    const bctxKeyToDefectiveCount: Record<string, number> = {};
    defectives.forEach((defective) => {
      if (!bctxKeyToDefectiveCount[defective.event.eventInfo.bctxDetails.bctxKey]) {
        bctxKeyToDefectiveCount[defective.event.eventInfo.bctxDetails.bctxKey] = 0;
      }
      bctxKeyToDefectiveCount[defective.event.eventInfo.bctxDetails.bctxKey]++;
    });
    const bctxKeyToIncompleteBundles: Record<string, TIncompleteBundle> = {};
    incompleteBundles.list.forEach((bundle) => {
      bctxKeyToIncompleteBundles[bundle.g_ctx_key] = bundle;
    });
    const activeBctxList: TBctxItemWithoutSizeAndBctxKey[] = [];
    Object.values(wipMap).forEach((wipMapItem) => {
      const availableWip = Object.values(wipMapItem.sizeToWipMap)[0].wip_qty;
      if (
        availableWip > 0 ||
        bctxKeyToDefectiveCount[wipMapItem.bctxKey] > 0 ||
        bctxKeyToIncompleteBundles[wipMapItem.bctxKey]
      ) {
        activeBctxList.push({
          list: wipMapItem.bctxItemListWithoutSize,
          bctxKey: wipMapItem.bctxKey,
        });
      }
    });
    return activeBctxList;
  },
);
